/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelRoutingGuideUsers.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const AutogenUserSavedSearchEndpoint = "lme/powerbroker/routing-guide-users";

export class AutogenModelRoutingGuideUsers<RowType extends ModelRow> extends Endpoint<RowType, RowRoutingGuideUsersFields> {
    constructor(ctor: RowConstructor) {
        super(AutogenUserSavedSearchEndpoint, ctor);
    }
}

export class AutogenRowRoutingGuideUsers extends ModelRow<RowRoutingGuideUsersFields> {
    constructor(values?: Partial<RowRoutingGuideUsersFields>) {
        super(AutogenUserSavedSearchEndpoint, true, values);
    }
}

export interface RowRoutingGuideUsersFields {
    company_id: string;
    descr: string;
    id: string;
    routing_guide_id: string;
    user_id: string;
}

